import { classnames } from '@src/utils/classnames';
import styles from './DataTableSkeleton.scss';
import { getClasses } from '@src/utils/getClass';
import { DATA_ELEM_HEAD } from '../consts';
import { Skeleton } from '@src/atoms/Skeleton';
import React, { FC } from 'react';
import { Box } from '@src/atoms/Box';
import { IDefaultComponentProps } from '@src/models/props';
import { TDataTableView } from '@src/molecules/DataTable/models';

export interface DataTableSkeletonProps extends IDefaultComponentProps {
  view: TDataTableView;
  headerHeight?: string | number;
  rowHeight?: string | number;
  rowsNumber?: number;
}

export const DataTableSkeleton: FC<DataTableSkeletonProps> = ({ view, headerHeight, rowHeight, rowsNumber }) => {
  const wrapperClasses = classnames(styles.root, ...getClasses(styles, { view }));
  return (
    <>
      <div className={wrapperClasses} data-elem={DATA_ELEM_HEAD} style={{ height: headerHeight }}>
        <Skeleton.Rect height={headerHeight} />
      </div>
      {[...Array(rowsNumber).keys()].map((el) => {
        return (
          <Box key={el} marginTop={8} marginBottom={8} className={wrapperClasses}>
            <Skeleton.Rect height={rowHeight} />
          </Box>
        );
      })}
    </>
  );
};
